import { Box, ColorOptions, Form, Icon, IconButton, LoaderNew, ModBox, Spacer, Text, TextNew } from '@jfs/ui-new'
import { TextInputNew } from '../../../components/AdminInputs'
import { ButtonNew } from '../../../components/AdminButton'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { ScrollView } from 'react-native'
import { Dropdown } from '../../../components/Dropdown'
import { useLazyApiData, useStores } from '../../../data/store'
import { checkDropdownData } from '../../../utils/constants'
import { AuthorisedForm, CinDetailsForm, DirectorForm, UboForm } from '../FiuCompliance/formData'
import { styles } from '../FiuQueue'
import FiuStatus from '../FiuStatus'

interface FiuDetailsProps {
  route: any
}
const FormBoxFull = ({ children }: any) => {
  return <Box w={'100%'}>{children}</Box>
}

const Header = ({ from, navigation, setSideMenuRefresh, type, applicationId }: any) => {
  const handleBack = () => {
    if (from === 'FIU_CHECKER') {
      navigation.navigate('fiuQueue')
      setSideMenuRefresh(true)
    } else if (from === 'FIU_MAKER') {
      navigation.navigate('fiuMakerQueue')
      setSideMenuRefresh(true)
    } else {
      navigation.goBack()
      setSideMenuRefresh(true)
    }
  }
  return (
    <ModBox borderBottomWidth={1} borderBottomColor={'BORDER_COLOR'}>
      <Box p={16}>
        <ModBox direction="row" justifyContent={'space-between'}>
          <ModBox direction="row" h={24} alignItems={'center'} justifyContent={'center'}>
            <ModBox>
              <IconButton id="ARROW_BACK" size={24} color={'#0070B6' as ColorOptions} onPress={handleBack} />
            </ModBox>
            <TextNew
              title={
                type === 'DIRECTOR'
                  ? 'Director Details'
                  : type === 'UBO'
                  ? 'UBO Details'
                  : type === 'AUTHORISED_SIGNATORY'
                  ? 'Authorised Signatory'
                  : 'CIN Details'
              }
            />
            <ModBox marginHorizontal={16}>
              <TextNew title={'|'} />
            </ModBox>
            <ModBox>
              <TextNew title={`Application Id: ${applicationId}`} />
            </ModBox>
          </ModBox>
        </ModBox>
      </Box>
    </ModBox>
  )
}
const Footer = ({ show, onSubmit }: any) => {
  const [status, setStatus] = useState('')
  const [comments, setComments] = useState('')
  const isFocus = useIsFocused()

  const onDropDownChange = (selected: string) => {
    setStatus(selected)
  }

  const mapper = {
    Approved: 'APPROVE',
    Rejected: 'REJECT',
  }

  const onHandleSubmit = () => {
    onSubmit && onSubmit(mapper[status], comments)
  }

  useEffect(() => {
    if (isFocus && (status !== '' || comments !== '')) {
      setComments('')
      setStatus('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!show) {
    return null
  }
  return (
    <ScrollView>
      <Box {...styles.footer}>
        <Box w={'100%'} alignItems={'center'} justifyContent={'space-between'} direction="row">
          <Box direction="row">
            <Box h={52}>
              <Text title={'Status'} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_75'} />
              <Spacer direction="vertical" size={8} />
              <Box borderWidth={1} borderColor={'BORDER_COLOR'} borderRadius={4}>
                <Dropdown
                  minHeight={32}
                  minWidth={150}
                  testID="selectStatus"
                  title={'Select Status'}
                  selectedData={onDropDownChange}
                  data={checkDropdownData}
                  value={status}
                  transparentBorder={true}
                />
              </Box>
            </Box>
            <Box marginLeft={16} width={367}>
              <Text title={"Checker's Comments"} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_75'} />
              <Spacer direction="vertical" size={8} />
              <Box
                borderWidth={1}
                borderColor={'BORDER_COLOR'}
                borderRadius={4}
                overflow={'auto'}
                nativeID="vertical-scroll"
                height={72}>
                <TextInputNew
                  placeholder={'Write your comments here...'}
                  value={comments}
                  onChangeText={setComments}
                  focusBorderColor={'TRANSPARENT'}
                  labelFontFamily={'jiotype-medium'}
                  fontSize={12}
                  paddingHorizontal={8}
                  paddingVertical={8}
                  numberOfLines={4}
                  multiline
                  maxLength={4096}
                />
              </Box>
            </Box>
          </Box>
          <ButtonNew
            onPress={onHandleSubmit}
            title={'Submit'}
            height={40}
            width={94}
            color={comments?.length === 0 || status?.length === 0 ? '#B9D3E7' : 'PRIMARY'}
            disabled={comments?.length === 0 || status?.length === 0}
          />
        </Box>
      </Box>
    </ScrollView>
  )
}

const FiuDetails = ({ route }: FiuDetailsProps) => {
  const { from, type, itemData, isApprovedByChecker, showApproveReject = false } = route?.params ?? {}

  const { approveRejectTask, setSideMenuRefresh } = useStores((store) => ({
    approveRejectTask: store.processFiuData,
    setSideMenuRefresh: store.setSideMenuRefresh,
  }))
  const [isCheckerApproved, setCheckerApproved] = useState(isApprovedByChecker)
  const [showCheckerStatus, setShowCheckerStatus] = useState(
    from && (from === 'FIU_CHECKER' || from === 'FIU_MAKER') ? isApprovedByChecker : false,
  )
  const [fetchApproveRejectTask, fetchApproveRejectTaskHandler] = useLazyApiData(approveRejectTask)
  const [approveRejectData, setApproveRejectData] = useState(
    from && (from === 'FIU_CHECKER' || from === 'FIU_MAKER')
      ? { apiResponse: {}, data: itemData }
      : { apiResponse: {}, data: {} },
  )
  const navigation = useNavigation()

  useEffect(() => {
    if (fetchApproveRejectTaskHandler?.state === 'fulfilled') {
      if (!showCheckerStatus) {
        setShowCheckerStatus(true)
        setApproveRejectData({ apiResponse: fetchApproveRejectTaskHandler?.data, data: itemData })
      }
    }
  }, [fetchApproveRejectTaskHandler?.data, fetchApproveRejectTaskHandler?.state, itemData, showCheckerStatus])

  const onApproveReject = (value: string, comments: string) => {
    setCheckerApproved(value === 'APPROVE')
    fetchApproveRejectTask(itemData?.taskInstanceId, value, comments, 'AUDIT')
  }

  const onNavigateToMyqueue = () => {
    setCheckerApproved(false)
    if (from === 'FIU_CHECKER') {
      navigation.reset({
        index: 0,
        routes: [{ name: 'fiuQueue' }],
      })
    } else if (from === 'FIU_MAKER') {
      navigation.reset({
        index: 0,
        routes: [{ name: 'fiuMakerQueue' }],
      })
    }
    setSideMenuRefresh(true)
  }

  const applicationsList =
    type === 'DIRECTOR'
      ? itemData?.directorDetails
      : type === 'UBO'
      ? itemData?.beneficialOwnerDetails
      : type === 'AUTHORISED_SIGNATORY'
      ? itemData?.authorisedSignatory
      : itemData?.businessProfile
  return (
    <>
      <ModBox {...styles.container} minHeight={'100%'}>
        <ModBox
          show={showCheckerStatus}
          position={'absolute'}
          zIndex={83937}
          width={'100%'}
          height={'100%'}
          backgroundColor={'WHITE'}>
          <FiuStatus isCheckerApproved={isCheckerApproved} data={approveRejectData} onSubmit={onNavigateToMyqueue} />
        </ModBox>
        <Header
          from={from}
          navigation={navigation}
          setSideMenuRefresh={setSideMenuRefresh}
          type={type}
          applicationId={itemData?.applicationId}
        />
        <ModBox marginHorizontal={32} marginTop={16}>
          <ModBox h={'100%'} minHeight={530}>
            {type === 'CIN' && applicationsList && (
              <ModBox w={'100%'} h={'100%'} minHeight={530}>
                <Form
                  formData={CinDetailsForm(
                    <Icon id={'CALENDAR'} size={15} color="PRIMARY" />,
                    false,
                    applicationsList?.dateOfIncorporation,
                  )}
                  actionButtons={() => null}
                  container={FormBoxFull}
                  initialValues={{
                    cinNumber: applicationsList?.cin ?? 'NA',
                    cinDate: applicationsList?.dateOfIncorporation ?? 'NA',
                  }}
                />
              </ModBox>
            )}
            {type !== 'CIN' &&
              applicationsList?.length > 0 &&
              applicationsList?.map((data) => {
                return (
                  <ModBox borderBottomWidth={1} borderBottomColor={'BORDER_COLOR'}>
                    <Form
                      formData={
                        type === 'DIRECTOR'
                          ? DirectorForm(
                              <Icon id={'CALENDAR'} size={15} color="PRIMARY" />,
                              data,
                              false,
                              true,
                              data?.beginAt?.length > 0,
                              false,
                            )
                          : type === 'UBO'
                          ? UboForm(<Icon id={'CALENDAR'} size={15} color="PRIMARY" />, data, false, true)
                          : type === 'AUTHORISED_SIGNATORY'
                          ? AuthorisedForm(<Icon id={'CALENDAR'} size={15} color="PRIMARY" />, data, false, true)
                          : CinDetailsForm(<Icon id={'CALENDAR'} size={15} color="PRIMARY" />, false, '')
                      }
                      actionButtons={() => null}
                      container={FormBoxFull}
                      initialValues={
                        type === 'DIRECTOR'
                          ? {
                              din: data?.din ?? 'NA',
                              firstName: data?.firstName ?? 'NA',
                              middleName: data?.middleName ?? 'NA',
                              lastName: data?.lastName ?? 'NA',
                              dob: data?.dob ?? 'NA',
                              beginAt: data?.beginAt ?? 'NA',
                              endAt: data?.endAt ?? 'NA',
                              directorReferenceId: data?.directorReferenceId,
                            }
                          : type === 'UBO'
                          ? {
                              uboFname: data?.firstName ?? 'NA',
                              uboMname: data?.middleName ?? 'NA',
                              uboLname: data?.lastName ?? 'NA',
                              uboDob: data?.dob ?? 'NA',
                              beneficialOwnerReferenceId: data?.beneficialOwnerReferenceId,
                            }
                          : type === 'AUTHORISED_SIGNATORY'
                          ? {
                              authSigFirstname: data?.authSigFirstname ?? 'NA',
                              authSigMidname: data?.authSigMidname ?? 'NA',
                              authSigLastname: data?.authSigLastname ?? 'NA',
                              authSigDOB: data?.authSigDOB ?? 'NA',
                              authorisedSignatoryReferenceId: data?.authorisedSignatoryReferenceId,
                            }
                          : {
                              cinNumber: data?.cin ?? 'NA',
                              cinDate: data?.dateOfIncorporation ?? 'NA',
                            }
                      }
                    />
                  </ModBox>
                )
              })}
          </ModBox>
        </ModBox>
        <ModBox
          marginHorizontal={32}
          show={
            itemData && (itemData?.applicationStatus === 'Completed' || itemData?.applicationStatus === 'Rejected')
          }>
          <Text
            title={`Checker Comments: ${itemData?.comments}`}
            color={'BLACK_21'}
            fontSize={14}
            fontFamily={'jiotype-medium'}
          />
        </ModBox>
        <ModBox show={fetchApproveRejectTaskHandler?.state === 'pending'}>
          <LoaderNew type={'small'} color={'PRIMARY'} />
        </ModBox>
        <ModBox backgroundColor={'WHITE'} show={showApproveReject}>
          <Footer
            show={from !== undefined || from === 'FIU_CHECKER' || from === 'FIU_MAKER'}
            onSubmit={onApproveReject}
          />
        </ModBox>
      </ModBox>
    </>
  )
}

export default FiuDetails
